import React from "react";
import { FileManager, FileUploader } from "reactjs-file-uploader";
import {
  SAVED_ICON,
  VIDEO_FILE,
  UPLOAD_PDF,
  RAR_FILE,
  DOC_FILE,
} from "./SrcImages";
import { Label, Input, Row, Col, Button } from "reactstrap";
import { urlHttpPostTaskStudent } from "./Services";
import moment from "moment";

interface IFileUploadState {
  files: any;
  type: string;
  format: string;
  msg_error: string;
  di_id: string;
  per_id: string;
  setNameFile: any;
  count: number;
  up_code: string;
  arrayFiles: {};
}

interface IFileUploadProps {
  namePdf: {
    di_id: string;
    per_id: string;
  };
  setNameFile: any;
}
class VanillaExample extends React.Component<
  IFileUploadProps,
  IFileUploadState
> {
  constructor(props: IFileUploadProps) {
    super(props);
    this.state = {
      files: [],
      type: "img",
      format: "",
      msg_error: "",
      di_id: props.namePdf.di_id,
      per_id: props.namePdf.per_id,
      setNameFile: props.setNameFile,
      count: 0,
      up_code: moment(new Date()).format("YYYYMMDDHHmmss"),
      arrayFiles: {},
    };
    this.uploadFiles = this.uploadFiles.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.fileProgress = this.fileProgress.bind(this);
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        <Row>
          {props.files.length === 0 ? (
            <React.Fragment>
              <Col xs={12} className="text-center mt-2 mb-3">
                <img src={UPLOAD_PDF} className="img-avatar" alt=""></img>
              </Col>
              <Col sm={1} className="text-center"></Col>
              <Col sm={10}>
                <Input
                  type="file"
                  multiple
                  className="m-auto"
                  onChange={(event) => {
                    var filess = [];
                    var msg_error = "";
                    for (var i = 0; i < event.target.files.length; i++) {
                      var lenght_type = 4;
                      if (
                        event.target.files[i].name.includes(".jpeg") ||
                        event.target.files[i].name.includes(".docx")
                      ) {
                        lenght_type = 5;
                      } else {
                        lenght_type = 4;
                      }

                      filess.push({
                        name: event.target.files[i].name,
                        id: i,
                        format: event.target.files[i].name.substring(
                          event.target.files[i].name.length - lenght_type
                        ),
                        type: event.target.files[i].type,
                      });

                      var name_file = "";

                      if (event.target.files[i].size > 24214400) {
                        msg_error = "Peso del archivo supero los 25mb";
                      }
                    }

                    if (this.state.msg_error.length === 0) {
                      this.setState({
                        files: props.files.concat(
                          Array.from(event.target.files)
                        ),
                        type: event.target.files[0].type,
                        format: name_file,
                        arrayFiles: filess,
                        count: event.target.files.length,
                        msg_error: "",
                      });
                    }
                    else{
                      this.setState({
                        msg_error:msg_error
                      });
                    }
                  }}
                />
              </Col>
              <Col sm={1} className="text-center">
                {" "}
              </Col>
            </React.Fragment>
          ) : null}

          <Col sm={12}>
            <Row>
            <FileManager files={props.files}>{this.uploadFiles}</FileManager>
            </Row>
          
          </Col>
          <Col sm={12} className="text-center mt-3">
            {this.state.msg_error.length > 0 ? (
              <Label className="l-color-danger">{this.state.msg_error}</Label>
            ) : (
              <Label>
                {props.files.length === 0 ? (
                  <Label className="l-color-danger">
                    Formatos permitidos: .mp4 .jpg .png .zip .doc .docx .pdf
                  </Label>
                ) : (
                  ""
                )}
              </Label>
            )}
          </Col>
        </Row>
      </React.Fragment>
    );
  }

  uploadFiles(files) {
    return files.map(this.uploadFile);
  }

  uploadFile(file) {
    var lenght_type = 4;
    var id = 0;
    for (var i = 0; i < this.state.count; i++) {
      if (this.state.arrayFiles[i].name === file.name) {
        id = i + 1;
        if (
          this.state.arrayFiles[i].name.includes(".docx") ||
          this.state.arrayFiles[i].name.includes(".jpeg")
        ) {
          lenght_type = 5;
        } else {
          lenght_type = 4;
        }
      }
    }
    return (
      <FileUploader
        key={file.key}
        file={file}
        url={urlHttpPostTaskStudent}
        formData={{
          file,
          upload_preset: "public",
          tags: "vanilla",
          di_id: this.state.di_id,
          per_id: this.state.per_id,
          nameImg:
            this.state.per_id +
            "_" +
            this.state.di_id +
            "_" +
            id +
            file.name.substring(file.name.length - lenght_type),
          count: this.state.count,
          up_code: this.state.up_code,
        }}
        readFile
      >
        {this.fileProgress}
      </FileUploader>
    );
  }

  fileProgress({
    uploadReady,
    uploadStart,
    uploadProgress,
    uploadComplete,
    downloadStart,
    downloadProgress,
    downloadComplete,
    error,
    abort,
    timeout,
    requestState,
    startUpload,
    abortRequest,
    request,
    response,
    fileData,
  }) {
    var urlImage = UPLOAD_PDF;
    if (fileData != null) {
      if (fileData.includes("/mp4")) {
        urlImage = VIDEO_FILE;
      }
      if (fileData.includes("/jpeg")) {
        urlImage = fileData;
      }
      if (fileData.includes("/png")) {
        urlImage = fileData;
      }
      if (fileData.includes("-zip")) {
        urlImage = RAR_FILE;
      }
      if (fileData.includes("octet-stream")) {
        urlImage = RAR_FILE;
      }
      if (fileData.includes("officedocument")) {
        urlImage = DOC_FILE;
      }
    }
    return (
      <React.Fragment>
        {this.state.count > 1 ? (
          // <Row>
            <Col sm={6} className="text-center">
              <img
                src={urlImage}
                width={200}
                alt="Preview"
                className="img-avatar"
              />
              {startUpload && (
                <Button
                  className="info"
                  onClick={() => {
                    startUpload();
                    this.state.setNameFile({
                      name_file:
                        this.state.per_id +
                        "_" +
                        this.state.di_id +
                        "_" +
                        this.state.count +
                        this.state.arrayFiles[0].format,
                      di_id: this.state.di_id,
                      per_id: this.state.per_id,
                      count: this.state.count,
                      up_code: this.state.up_code,
                    });
                  }}
                >
                  Guardar
                </Button>
              )}
              {response && (
              <React.Fragment>
                <Label>Guardado</Label>
                <img className="img-status img-search m-auto" src={SAVED_ICON} alt="" />
              </React.Fragment>
            )}
            </Col>
          // </Row>
        ) : (
          <React.Fragment>
            <Col sm={12} className="text-center">
              <img
                src={urlImage}
                width={200}
                alt="Preview"
                className="img-avatar"
              />
            </Col>
            <Col sm={12} className="text-center">
              {startUpload && (
                <Button
                  className="info mt-2"
                  onClick={() => {
                    startUpload();
                    this.state.setNameFile({
                      name_file:
                        this.state.per_id +
                        "_" +
                        this.state.di_id +
                        "_" +
                        this.state.count +
                        this.state.arrayFiles[0].format,
                      di_id: this.state.di_id,
                      per_id: this.state.per_id,
                      count: this.state.count,
                      up_code: this.state.up_code,
                    });
                  }}
                >
                  Guardar
                </Button>
              )}
            </Col>
            <Col sm={12} className="save-upload-img">
              {response && (
                <React.Fragment>
                  <Label>Guardado</Label>
                  <img
                    className="img-status img-search"
                    src={SAVED_ICON}
                    alt=""
                  />
                </React.Fragment>
              )}
            </Col>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}
export default VanillaExample;
